import { Component, inject, OnInit } from '@angular/core';
import { CardComponent } from '../card/card.component';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { IAppState } from '../../ngrx';
import { BaseComponent } from '../../shared/components/base/base.component';
import { TranslateModule } from '@ngx-translate/core';
import { StatisticsService } from '../../statistic/services/statistics/statistics.service';
import { NgTemplateOutlet } from '@angular/common';



@Component({
    selector: 'app-benefits',
    templateUrl: './benefits.component.html',
  imports: [
    TranslateModule,
    CardComponent,
    NgTemplateOutlet
  ],
    styleUrls: ['./../website-grid.scss', './benefits.component.scss']
})
export class BenefitsComponent extends BaseComponent implements OnInit {
  private statisticsService = inject(StatisticsService);

  deviceType: string = 'mobile';
  donationAmounts: string;

  constructor(
    private _store: Store<IAppState>,
  ) {
    super();
  }

  get isMobile(): boolean {
    return this.deviceType === 'mobile';
  }

  get isTablet(): boolean {
    return this.deviceType === 'tablet';
  }

  get isDesktop(): boolean {
    return this.deviceType === 'desktop';
  }

  ngOnInit(): void {
    this._store.select(s => s.ui.device).pipe(
        takeUntil(this.destroy$))
        .subscribe((device) => {
          this.deviceType = device.calculatedDeviceType;
        }
    );

    this.getDonationAmounts();
  }

  getDonationAmounts(): void {
    this.statisticsService.getDonationAmount().subscribe({
      next: (res) => {
        this.donationAmounts = this.transformDonationAmounts(res.count);
      },
    });
  }

  transformDonationAmounts(amount: number): string {
    if (amount >= 1000) {
      return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    } else {
      return amount.toString();
    }
  }

}
